import React from 'react';
import { UI_CONSTANTS } from '../../constants/ui';

interface ErrorDisplayProps {
  error: string;
  onRetry?: () => void;
  title?: string;
  retryLabel?: string;
  className?: string;
}

export const ErrorDisplay: React.FC<ErrorDisplayProps> = ({ 
  error, 
  onRetry,
  title,
  retryLabel = 'Retry',
  className = '' 
}) => {
  const isApiKeyError = error.includes('API Key') || error.includes('not configured');
  const displayTitle = title || (isApiKeyError ? 'Configuration Required' : 'Error Loading Data');
  const displayMessage = isApiKeyError
    ? 'Please configure your API key in Settings to view data.'
    : error;

  return (
    <div className={`p-6 ${UI_CONSTANTS.COLORS.red.background} border ${UI_CONSTANTS.COLORS.red.border} rounded-lg ${className}`}>
      <div className="flex items-start gap-3">
        <div className="flex-shrink-0">
          <svg className={`w-6 h-6 text-red-600 dark:text-red-400`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
          </svg>
        </div>
        <div className="flex-1">
          <h3 className={`font-medium ${UI_CONSTANTS.COLORS.red.title} mb-2`}>
            {displayTitle}
          </h3>
          <p className={`${UI_CONSTANTS.COLORS.red.text} mb-4 text-sm`}>
            {displayMessage}
          </p>
          {onRetry && (
            <button 
              onClick={onRetry}
              className={`px-4 py-2 ${UI_CONSTANTS.COLORS.red.button} text-white text-sm font-medium rounded-lg ${UI_CONSTANTS.ANIMATIONS.transition}`}
            >
              {retryLabel}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ErrorDisplay;